import { UserDTOKycItemStatus } from "@/generated/api/models";

export const getActiveKYC = <T extends { status: UserDTOKycItemStatus }>(
  kyc?: T | Array<T> | null
) => {
  if (!kyc) {
    return undefined;
  }

  if (Array.isArray(kyc)) {
    return kyc.find((c) => c.status === "CREATED" || c.status === "PENDING");
  }

  return kyc.status === "CREATED" || kyc.status === "PENDING" ? kyc : undefined;
};
